import type {Endpoints} from "@hosttools/web/server/routes/routes.quickReply.types";
import type {AxiosRequestConfig} from "axios";
import type {PaginateResult} from "mongoose";

import type {QuickReplyRaw} from "../../models/quickReply";
import {Base} from "../base";

export class QuickReplyService extends Base<Endpoints> {
    async fetchMessages({
        offset,
        limit = 20,
        search
    }: {
        limit: number;
        offset: number;
        search?: string;
    }) {
        const {data} = await this.http.get<PaginateResult<QuickReplyRaw>>(
            `/quickReplies?offset=${offset}&limit=${limit}${search ? `&keyword=${search}` : ""}`
        );

        return {
            ...data,
            docs: data.docs
        };
    }

    async deleteMessage(id: string) {
        await this.http.post("/deleteQuickReply", {
            quickReplyID: id
        });
    }

    async buildTextForReservation(reservationID: string, message: string) {
        const {data} = await this.http.post<{message: string}>(
            `/quickReply/buildText/${reservationID}`,
            {
                text: message
            }
        );
        return data.message;
    }

    async fetchSuggestion(reservationID: string, config?: AxiosRequestConfig) {
        const {data} = await this.http.post<{message: string}>(
            `/quickReply/autoComplete/${reservationID}`,
            {},
            config
        );
        return data.message;
    }
}
